import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `TipoDosis/addTipoDosis`, method: 'POST', body: values, token: token})
}